import {
  Home,
  Settings,
  Box,
  Users,
  UserPlus,
  Zap,
  DollarSign,
  MessageSquare,
  TrendingUp,
  Gift,
  Slash,
  Award,
} from "react-feather";

export const MENUITEMS = [
  {
    path: "/dashboard",
    title: "Dashboard",
    icon: Home,
    type: "link",
    badgeType: "primary",
    active: false,
    access: "Dashboard",
  },
  // {
  //   title: 'Jackpot Settings',
  //   icon: Tool,
  //   path: '/jackpot-settings',
  //   type: 'link',
  //   access: 'JackpotSettings',
  // },

  {
    title: "Warehouse",
    icon: Box,
    type: "sub",
    active: false,
    access: "Warehouse" || "Category",
    children: [
      {
        title: "Marketplace",
        icon: Box,
        path: "/products/list_product",
        type: "link",
        access: "Product",
      },
      {
        title: "Rake Inventory",
        icon: Box,
        path: "/products/list_rake_inventory",
        type: "link",
        access: "Product",
      },
    ],
  },

  {
    title: "User Management",
    icon: Users,
    type: "sub",
    active: false,
    access: "allusers" || "onlineusers",
    children: [
      {
        title: "All Users",
        path: "/users/list-user",
        type: "link",
        access: "allusers",
      },
      {
        title: "Online Users",
        icon: Box,
        path: "/users/online-users",
        type: "link",
        access: "onlineusers",
      },
    ],
  },

  {
    title: "Transaction",
    icon: DollarSign,
    path: "/transaction/list_transaction",
    type: "link",
    access: "Transaction",
  },
  {
    title: "Game History",
    icon: TrendingUp,
    path: "/game-history/list_game_history",
    type: "link",
    access: "Transaction",
  },

  {
    title: "Affiliate",
    icon: UserPlus,
    type: "sub",
    active: false,
    access: "Affiliate",
    children: [
      // {
      //   title: 'Affiliate Commission',
      //   icon: Users,
      //   path: '/affiliate-commission',
      //   type: 'link',
      //   access: 'AffiliateLevel',
      // },
      {
        title: "Affiliate Users",
        icon: Users,
        path: "/affiliate-users",
        type: "link",
        access: "AffiliateUsers",
      },
      {
        title: "Affiliate Stats",
        icon: TrendingUp,
        path: "/affiliate-stats",
        type: "link",
        access: "AffiliateUsers",
      },
      {
        title: "Generate Affiliate Link",
        icon: Users,
        path: "/generate-affiliate-link",
        type: "link",
        access: "AffiliateUsers",
      },
    ],
  },

  // {
  //   title: 'Rake Settings',
  //   icon: Tool,
  //   path: '/rake-settings',
  //   type: 'link',
  //   access: 'RakeSettings',
  // },
  {
    title: "Support Chat",
    icon: MessageSquare,
    path: "/supportChatManagement",
    type: "link",
    access: "SupportChatManagement",
  },
  {
    title: "Deposit Management",
    icon: Zap,
    type: "sub",
    active: false,
    access: "ProfitManagement",
    children: [
      // {
      //   title: 'Withdraws',
      //   icon: Box,
      //   path: '/funds-management',
      //   type: 'link',
      //   access: 'Withdraws',
      // },
      // {
      //   title: 'Order Management',
      //   icon: Box,
      //   path: '/order-management',
      //   type: 'link',
      //   access: 'Orders',
      // },
      {
        title: "Crypto deposits",
        icon: Box,
        path: "/deposite-mangement",
        type: "link",
        access: "Deposits",
      },
      {
        title: "Deposit Blacklist",
        icon: Slash,
        path: "/deposit-blacklist",
        type: "link",
        access: "Deposits",
      },
    ],
  },
  {
    title: "Team Management",
    icon: UserPlus,
    type: "sub",
    active: false,
    access: "TeamManagement",
    children: [
      {
        title: "Team Members",
        icon: Users,
        path: "/team-management",
        type: "link",
      },
      {
        title: "Activity Log",
        icon: Users,
        path: "/activityLog",
        type: "link",
        access: "ActivityLog",
      },
    ],
  },
  {
    title: "Gift Card Management",
    icon: Gift,
    path: "/gift-card",
    type: "link",
    access: "SupportChatManagement",
  },
  {
    title: "Giveaway Management",
    icon: Award,
    path: "/giveaway-management",
    type: "link",
    access: "giveawayManagement",
  },
  {
    title: "Region Restriction",
    icon: Slash,
    path: "/region-restriction",
    type: "link",
    access: "RegionRestriction",
  },
  {
    title: "Settings",
    icon: Settings,
    type: "sub",
    access: "Setting",
    children: [
      {
        path: "/settings?tab=profile",
        title: "Profile",
        type: "link",
        access: "Profile",
      },
      {
        path: "/settings?tab=changePassword",
        title: "Change Password",
        type: "link",
        access: "ChangePassword",
      },
      {
        path: "/settings?tab=preferences",
        title: "Preferences",
        type: "link",
        access: "Preferences",
      },
    ],
  },
];
